"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "fiscaglia": {
    "e175bb66": [{
      "hkey": "615bfcde",
      "slug": "cornacervina",
      "name": "Cornacervina",
      "primary": true,
      "skipSearch": false
    }],
    "bassa-cornacervina": [{
      "hkey": "615bfcde",
      "slug": "cornacervina",
      "name": "Cornacervina",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "56c20efb": [{
      "hkey": "1453249d",
      "slug": "fiscaglia",
      "name": "Fiscaglia",
      "primary": true,
      "skipSearch": false
    }],
    "gallumara": [{
      "hkey": "1453249d",
      "slug": "fiscaglia",
      "name": "Fiscaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "84ab4a3a": [{
      "hkey": "1453249d",
      "slug": "fiscaglia",
      "name": "Fiscaglia",
      "primary": true,
      "skipSearch": false
    }],
    "tieni": [{
      "hkey": "1453249d",
      "slug": "fiscaglia",
      "name": "Fiscaglia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;